import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import {
  CONTROLS_ROW_BUTTON_CLASS_NAME,
  CONTROLS_ROW_BUTTON_WRAPPER_CLASS_NAME,
  CONTROLS_ROW_CLASS_NAME,
  CONTROLS_ROW_LABEL_CLASS_NAME,
} from "@/components/doc/left-sidebar/controlsRowStyles";
import { useCreateChat } from "@/components/doc/left-sidebar/team-chats/useCreateChat";
import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";
import { twMerge } from "@/utils/twMerge";

// No search here: search only covers documents
export const ChatsTabControls = observer(function ChatsTabControls() {
  const t = useTranslations("documentsSidebar");
  const { createChat, isCreating } = useCreateChat();

  return (
    <div
      className={twMerge("flex items-center", CONTROLS_ROW_CLASS_NAME)}
      data-testid="chats-tab-controls"
    >
      <Sidebar.Button
        onClick={createChat}
        disabled={isCreating}
        icon={<Icon name="chat/NewChat" className="sm:w-[28px] sm:h-[28px] mr-1" />}
        title={t("newChat")}
        className={twMerge(CONTROLS_ROW_BUTTON_CLASS_NAME, CONTROLS_ROW_LABEL_CLASS_NAME)}
        wrapperClassName={CONTROLS_ROW_BUTTON_WRAPPER_CLASS_NAME}
      >
        {t("newChat")}
      </Sidebar.Button>
    </div>
  );
});
